import { Tooltip } from "antd";
import { forwardRef } from "react";
import classNames from "classnames";
import type { TooltipRef } from "antd/lib/tooltip";
import type { TooltipProps } from "antd";
import styles from "./styles.module.scss";

export type AppTooltipProps = TooltipProps;

export const AppTooltip = forwardRef<TooltipRef, AppTooltipProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Tooltip ref={ref} className={classNames(styles.tooltip, className)} {...props}>
        {children}
      </Tooltip>
    );
  },
);
